import {Checker} from "../../../toolkit";

export abstract class Appendat<T> {
  private readonly _argument: T;

  private _condition: boolean;
  private _callback?: IAppendCallback<T>;

  protected constructor(
    argument: T,
    condition: boolean,
    callback?: IAppendCallback<T>,
  ) {
    this._argument = argument;
    this._condition = condition;
    this._callback = callback;
  }

  get condition(): boolean {
    return this._condition
  }

  public callback(callback: IAppendCallback<T>): Appendat<T> {
    this._callback = callback;
    return this;
  }

  public quote(): Appendat<T> {
    return this;
  }

  argument(): T | undefined {
    if (!Checker.truthy(this._callback))
      return this._argument;
    if (!Checker.truthy(this._argument))
      return undefined;
    return this._callback.callback(this._argument);
  }

}

export interface IAppendCallback<T> {
  callback(data: T): T;
}

export class TextAppendat extends Appendat<string> {

  private _quote: boolean;

  constructor(argument: string, condition?: boolean, callback?: IAppendCallback<string>) {
    super(argument, condition ?? true, callback);
    this._quote = false;
  }

  /**
   * Create new text appendat
   * @param argument argument
   * @param options options: { condition: condition for this arg, callback: value callback }
   */
  public static create(
    argument: string,
    options?: {
      condition?: boolean,
      callback?: (value: string) => string,
    }) {
    return new TextAppendat(
      argument,
      options?.condition ?? true,
      new class implements IAppendCallback<string> {
        callback(data: string): string {
          const cb = options?.callback;
          if (cb) {
            return cb(data);
          }
          return data;
        }
      },
    )
  }

  callback(callback: IAppendCallback<string>): TextAppendat {
    super.callback(callback);
    return this;
  }

  quote(): TextAppendat {
    this._quote = true;
    return this;
  }

  argument(): string | undefined {
    const arg = super.argument();
    if (!Checker.truthy(arg))
      return this._quote ? '""' : '';
    if (this._quote) {
      return `"${arg}"`;
    }
    return arg;
  }
}
